/**
 * Spec 034 (2/2) — os clientes de cada login de portal, pela tela de usuários.
 * As chaves ficam sob ['erp', 'users'] para o invalidate da tela alcançá-las.
 */
import { queryOptions } from '@tanstack/react-query';
import type { UserClientLink } from '@erp/shared';
import { api } from '@/lib/api-client';

/** A coluna "Cliente": os vínculos dos logins de portal da PÁGINA (até 200 ids). */
export function userClientLinksQuery(userIds: readonly number[]) {
  const ids = [...userIds].sort((a, b) => a - b);
  return queryOptions({
    queryKey: ['erp', 'users', 'client-links', ids] as const,
    enabled: ids.length > 0,
    staleTime: 60_000,
    queryFn: async ({ signal }) => {
      const res = await api<UserClientLink[]>('/users/client-links', {
        query: { userIds: ids.join(',') },
        signal,
      });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}

/** Os clientes de um login (o diálogo de edição). */
export function loginClientsQuery(userId: number) {
  return queryOptions({
    queryKey: ['erp', 'users', 'clients', userId] as const,
    queryFn: async ({ signal }) => {
      const res = await api<UserClientLink[]>(`/users/${userId}/clients`, { signal });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}
